module.exports = __webpack_public_path__ + "img/transnistria.3636b075.svg";